import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import { AuthProvider } from './context/AuthContext';

window.React1 = require('react');

// Add this in your component file
require('react-dom');
window.React2 = require('react');


console.log(window.React1 === window.React2);


ReactDOM.render(
  <AuthProvider>
    <App />

  </AuthProvider>
  ,
  document.getElementById('root'));
